<!--  ******************************************************  -->
<!--  ADD or UPDATE USER DIALOG                           -->
<!--    - Allows the customerUser to insert or update a customer      -->
<!--  ******************************************************  -->
<mat-toolbar class="dialogToolbar">
  <h2 mat-dialog-title fxFlex>
    {{'USER.ADD' | translate}}
  </h2>
  <button mat-icon-button color="accent" [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<mat-dialog-content class="mat-typography dialogBody">


    <form class="example-form" #putUser="ngForm">

      <!--  ************************************  -->
      <!--              CUSTOMER USER             -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField">
        <mat-label>{{'CUSTOMER.TITLE' | translate}}</mat-label>
        <input matInput required #customerTitle="ngModel" type="text" disabled name="customerTitle" [(ngModel)]="data.customer.title">
      </mat-form-field>


      <!--  ************************************  -->
      <!--            USER FIRST NAME             -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField">
        <mat-label>{{'USER.FIRSTNAME' | translate}}</mat-label>
        <input matInput required #userFirstName="ngModel" type="text" name="userFirstName" [(ngModel)]="data.user.firstname">
        <mat-error *ngIf="userFirstName.invalid">
          {{'USER.FIRSTNAME_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <!--  ************************************  -->
      <!--             USER LAST NAME             -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField">
        <mat-label>{{'USER.LASTNAME' | translate}}</mat-label>
        <input matInput required #userLastName="ngModel" type="text" name="userLastName" [(ngModel)]="data.user.lastname">
        <mat-error *ngIf="userLastName.invalid">
          {{'USER.LASTNAME_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <!--  ************************************  -->
      <!--               USER EMAIL               -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField">
        <mat-label>{{'USER.EMAIL' | translate}}</mat-label>
        <input matInput required #userEmail="ngModel" name="userEmail" type="email" pattern='{{gmService.EMAIL_PATTERN_VALIDATOR}}'  [(ngModel)]="data.user.email">
        <mat-error *ngIf="userEmail.errors?.required">
          {{'USER.EMAIL_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
        </mat-error>
        <mat-error *ngIf="userEmail.dirty && data.user.email !== '' && userEmail.invalid">
          {{'USER.EMAIL_FIELD' | translate }} <strong>{{'COMMON.IS_IN_WRONG_FORMAT' | translate }}</strong>
        </mat-error>
      </mat-form-field>

    </form>
</mat-dialog-content>

<mat-divider></mat-divider>

<!--  *****************************************  -->
<!--    CLOSE/SAVE DIALOG ACTION BUTTON          -->
<!--  *****************************************  -->
<mat-dialog-actions align="end" class="dialogFooter">
  <button mat-button [mat-dialog-close]="null">{{'BUTTONS.CLOSE' | translate}}</button>
  <button mat-button class="primaryButton" [disabled]="putUser.invalid" (click)="saveCustomerUser()">{{'BUTTONS.SAVE' | translate}}</button>
</mat-dialog-actions>
